import Draggable20 from '@carbon/icons-react/es/draggable/20';
import { Tooltip } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SortableHandle } from 'react-sortable-hoc';
import styled from 'styled-components';
import { Text03 } from '../../styles';
import { Button, ButtonProps } from '../button';

const DraggableHandle = styled(Button)`
  cursor: grab;
  ${Text03};
`;

export const DragHandle = SortableHandle((props: ButtonProps) => (
  <Tooltip title={<FormattedMessage id="drag_reorder" />}>
    <DraggableHandle {...props} type="text" icon={<Draggable20 />} />
  </Tooltip>
));
